import { Component, OnInit, Inject, OnDestroy } from '@angular/core';
import { UntypedFormBuilder, UntypedFormGroup, Validators } from '@angular/forms';
import { MatDialog, MatDialogRef, MAT_DIALOG_DATA } from '@angular/material/dialog';
import { TranslateService } from '@ngx-translate/core';
import { Location } from '@angular/common';
import { Store } from '@ngrx/store';
import { Subscription } from 'rxjs';
import { FacilitiesService, Facility } from '../../../../../core/linked-tables';
import { LayoutUtilsService } from '../../../../../core/_base/crud';
import { AppState } from '../../../../../core/reducers';

@Component({
    selector: 'kt-alt-facility-add',
    templateUrl: './facility-add-dialog.component.html',
    styleUrls: ['./facility-add-dialog.component.scss']
})

export class FacilityAddDialogComponent implements OnInit, OnDestroy {

    facility: Facility;
    facilityForm: UntypedFormGroup;
    hasFormErrors = false;
    
    private componentSubscriptions: Subscription;
    
    /**
     * Component constructor
     *
     * @param dialogRef
     * @param data
     * @param dialog: MatDialog
     * @param location
     * @param fb
     * @param layoutUtilsService: LayoutUtilsService
     * @param translate: TranslateService
     * @param facilitiesService
     * @param store: Store<AppState>
     */
    constructor(public dialogRef: MatDialogRef<FacilityAddDialogComponent>,
                @Inject(MAT_DIALOG_DATA) public data: any,
                public dialog: MatDialog,
                public location: Location,
                private fb: UntypedFormBuilder,
                private layoutUtilsService: LayoutUtilsService,
                private translate: TranslateService,
                private facilitiesService: FacilitiesService,
                private store: Store<AppState>) {
    }
    
    /**
     * On init
     */
    ngOnInit() {
        this.facility = new Facility();
        this.facility.clear();
        this.initFacility();
    }
    
    initFacility() {
        this.createForm();
    }
    
    createForm() {
        this.facilityForm = this.fb.group({
            name: [this.facility.name, Validators.required]
        });
    }
    
    /**
     * Returns prepared assignment
     */
    prepareFacility(): Facility {
        const controls = this.facilityForm.controls;
        const _facility = new Facility();
        _facility.clear();
        _facility.id = this.facility.id;
        _facility.name = controls.name.value;
        _facility.is_building = this.data.is_building;
        _facility.asset_type_id = this.data.asset_class_type_id;
    
        return _facility;
    }
    
    createFacility() {
        this.hasFormErrors = false;
        const controls = this.facilityForm.controls;
        /** check form */
        if (this.facilityForm.invalid) {
            Object.keys(controls).forEach(controlName =>
                controls[controlName].markAsTouched()
            );
    
            this.hasFormErrors = true;
            return;
        }
    
        const _facility = this.prepareFacility();
    
        this.facilitiesService.createFacility(_facility).subscribe((res) => {
                if (res.data) {
                    this.dialogRef.close({facility: res.data});
                    return;
                }
            }
        );
    }
    
    isFormValid() {
        const controls = this.facilityForm.controls;
    
        return (controls.name.value);
    }
    
    close() {
        this.dialogRef.close();
    }
    
    ngOnDestroy(): void {
        if (this.componentSubscriptions) {
            this.componentSubscriptions.unsubscribe();
        }
    }
}
